$(document).ready(initContactForm);

function initContactForm() {
  const selectElements = document.querySelectorAll(".custom-select");
  selectElements.forEach((selectElement) => {
    selectElement.addEventListener("change", function () {
      if (this.value !== "") {
        this.classList.add("option-selected");
      } else {
        this.classList.remove("option-selected");
      }
    });
  });
}
